import React from 'react';
import { Create, List, Datagrid, TextField,  BooleanInput, Edit,SimpleForm,DisabledInput  } from 'react-admin';
import {  BooleanField,  TextInput, Toolbar, SaveButton } from 'react-admin';
import {   EditButton } from 'react-admin';
import { ReferenceInput, SelectInput, ReferenceField } from 'react-admin';

export const ClientTypeList = props => (
    <List {...props} bulkActionButtons={null}>
        <Datagrid >
            <EditButton />
            <TextField source="id" />
            <TextField source="description" />
            <ReferenceField source="folder" reference="folders2" linkType={false} >
                <TextField source="FullName" />
            </ReferenceField>
            <BooleanField source="active" />
        </Datagrid>
    </List>
);

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />  
    </Toolbar>
);

/// in src/clienttypes.js
export const ClientTypeEdit = props => (
    <Edit title={<ClientTypeTitle />} {...props}   >
        <SimpleForm validate={validateClientTypeCreation} toolbar={<PostEditToolbar />} redirect="list" >
           <DisabledInput source="id" />
           <TextInput source="description" />
           <ReferenceInput source="folder" reference="folders"  label="Folder" fullWidth allowEmpty >
               <SelectInput optionText="name" />
            </ReferenceInput>
           <BooleanInput source="active"   />
        </SimpleForm>
    </Edit>
);
///
export const ClientTypeCreate = props => (
    <Create {...props}>
        <SimpleForm validate={validateClientTypeCreation} redirect="list" >
            <DisabledInput source="id" />
           <TextInput source="description" />
            <ReferenceInput source="folder" reference="folders"  label="Folder" fullWidth allowEmpty >
               <SelectInput optionText="name" />
            </ReferenceInput>
            <BooleanInput source="active" defaultValue={true} />
        </SimpleForm>
    </Create>
);

///
const validateClientTypeCreation = (values) => {
    const errors = {};
    if (!values.description) {
        errors.description = ['The description is required'];
    }
    if (!values.folder) {
        errors.description = ['The folder is required'];
    }
   
     
    return errors
};

const ClientTypeTitle = ({ record }) => {
    return <span>Client Type: {record ? `"${record.description}"` : ''}</span>;
};
